module.exports = __webpack_public_path__ + "media/Resources/Presentation-2e1ab076.svg";